<template>
  <div>极速</div>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped></style>
